const FoodPost = [
    {
      id:1,
      img:"https://static.toiimg.com/thumb/95606600.cms?width=680&height=512&imgsize=94134",
      title:"Fruit can fix breathing issues to digestion",
      details: "As kids we have been told about the umpteen benefits of including fruits in our day-to-day diet. Well, here’s all you need to know about this exotic fruit.",
      date:"Nov 12, 2022",
      type:"Food"
    },
    {
      id:2,
      img:"https://static.toiimg.com/thumb/95560619.cms?width=680&height=512&imgsize=198828",
      title:"To make restaurant style Italian food at home",
      details: "We all love and crave Italian food. But eating out daily might not be the best option and a viable one.  So why not dish out some healthy Italian fare at home?",
      date:"Nov 12, 2022",
      type:"Food"
      
    },
    {
        id:3,
        img:"https://static.toiimg.com/photo/95629614.cms",
        title:"Eating a handful of pista chios may improve heart",
        details:"One of the most loved shell nuts-- pistachios have been an inseparable part of Indian cuisine, but do you know eating these little nuts daily may improve heart health. ",
        date:"Nov 12, 2022",
        type:"Food"
    },
    {
        id:4,
        img:"https://static.toiimg.com/thumb/95562564.cms?width=680&height=512&imgsize=177996",
        title:"Adding this leaf to boiling rice can give a basmati",
        details: "Popularly known as the ‘Vanilla of the East’, Pandan leaves or ‘Annapoorna Leaves’ are one of your best bets when it comes to aromatic basmati rice.",
        date:"Nov 12, 2022",
        type:"Food",
        num:1
    }    
  ]
  export default FoodPost;

export const FoodFirstPost = [
{
  id:1,
  img:"https://static.toiimg.com/thumb/95650985.cms?width=680&height=512&imgsize=72808",
  title:"Passion fruit peels help preserve fruit",
  date:"Nov 13, 2022",
  type:"Food",
  num:"1"
}
]
export const FoodTopPost = [
  {
    id:1,
    img:"https://static.toiimg.com/thumb/95536030.cms?width=680&height=512&imgsize=72230",
    title:"Aluminium foil is danger",
    date:"Nov 13, 2022",
    type:"Food",
    num:"2"
  },
  {
    id:2,
    img:"https://static.toiimg.com/thumb/msid-95511666,width-800,height-600,resizemode-75,imgsize-65912,pt-32,y_pad-40/95511666.jpg",
    title:"Chicken soup for the soul",
    date:"Nov 13, 2022",
    type:"Food",
    num:"3"
  },
  {
    id:3,
    img:"https://static.toiimg.com/thumb/95536253.cms?width=680&height=512&imgsize=80446",
    title:"Cucumber consumtion",
    date:"Nov 12, 2022",
    type:"Food",
    num:"4"
  },
  {
    id:4,
    img:"https://static.toiimg.com/thumb/95432567.cms?width=680&height=512&imgsize=141120",
    title:"Raw papaya are best",
    date:"Nov 12, 2022",
    type:"Food",
    num:"5"
  }
  ]